import { render, staticRenderFns } from "./DoTplDialog.vue?vue&type=template&id=333799d2&scoped=true"
import script from "./DoTplDialog.vue?vue&type=script&lang=js"
export * from "./DoTplDialog.vue?vue&type=script&lang=js"
import style0 from "./DoTplDialog.vue?vue&type=style&index=0&id=333799d2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333799d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333799d2')) {
      api.createRecord('333799d2', component.options)
    } else {
      api.reload('333799d2', component.options)
    }
    module.hot.accept("./DoTplDialog.vue?vue&type=template&id=333799d2&scoped=true", function () {
      api.rerender('333799d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/DoTplDialog.vue"
export default component.exports